export default __webpack_public_path__ + "static/onze_aanpak_1-7b461884d7318bc380fc18c6f1715e4d.jpg";